import { Sparkle, ChatCircleDots, TrendUp, List, Megaphone } from "@phosphor-icons/react";

// Fixed bottom tab bar shown only on mobile (lg:hidden). The 5th item opens
// the full-screen menu drawer rather than switching tabs.
const MobileBottomNav = ({ activeTab, setActiveTab, onOpenMenu }) => {
  const tabs = [
    { key: "discover", label: "Discover", icon: Sparkle, on: () => setActiveTab("discover") },
    { key: "pain_points", label: "Pain", icon: Megaphone, on: () => setActiveTab("pain_points") },
    { key: "trending", label: "Trending", icon: TrendUp, on: () => setActiveTab("trending") },
    { key: "copilot", label: "Advisor", icon: ChatCircleDots, on: () => setActiveTab("copilot") },
    { key: "__menu", label: "Menu", icon: List, on: onOpenMenu },
  ];
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-zinc-200 flex items-stretch" data-testid="mobile-bottom-nav" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      {tabs.map((t) => {
        const Icon = t.icon;
        const active = t.key !== "__menu" && activeTab === t.key;
        return (
          <button key={t.label} onClick={t.on} data-testid={`mobile-nav-${t.label.toLowerCase()}`}
            className={`flex-1 min-h-[58px] flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors ${active ? "text-violet-700" : "text-zinc-500"}`}>
            <Icon size={21} weight={active ? "fill" : "duotone"} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
